import { InjectionToken } from '@angular/core';

export interface StateSaver<TState, TStateStorage> {
    save(state: TState): TStateStorage;
}

export interface StateLoader<TStateStorage, TState> {
    load(state: TStateStorage | undefined): TState;
}

export const _STATE_STORAGE_PERSIST_SERVICE = new InjectionToken('Internal state storage persist service - single instance');
